import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewPropertyList = (propertyData, showLoader = true) => {
  return async (dispatch) => {
    // if (showLoader) {
    //   dispatch({ type: "START_LOADING" });
    // }
    try {
      dispatch({ type: "GET_PROPERTY_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/property/list`,
        propertyData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_PROPERTY_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_PROPERTY_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_PROPERTY_LIST_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};


export const viewProperty = (propertyData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_PROPERTY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/property/${propertyData}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_PROPERTY_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_PROPERTY_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_PROPERTY_FAILED", payload: error.message });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addProperty = (propertyData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_PROPERTY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/property/add`,
        propertyData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_PROPERTY_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_PROPERTY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_PROPERTY_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const EditProperty = (propertyData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_PROPERTY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/property/update`,
        propertyData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_PROPERTY_SUCCESS", payload: data });
        toast.success("Edit Successful!!");
        return data;
      } else {
        dispatch({ type: "EDIT_PROPERTY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "EDIT_PROPERTY_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getSubcategories = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_SUBCATEGORY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/unit/alllist`,
        id,
        config
      );
console.log(data,"sweeep")
      if (data.statusCode === 200) {
        dispatch({ type: "GET_SUBCATEGORY_SUCCESS", payload: data });
        toast.success("Subcategory Fetch Successful!!");
        return data;
      } else {
        dispatch({ type: "GET_SUBCATEGORY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_SUBCATEGORY_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
}


export const updateRewardPoints = (rewardData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_REWARD_POINTS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      
      const { data } = await axios.post(
        `${BASE_URL}/property/update-reward-points`,
        rewardData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_REWARD_POINTS_SUCCESS", payload: data });
        toast.success("Reward Points Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "UPDATE_REWARD_POINTS_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_REWARD_POINTS_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Update failed!");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const getCityTotalPrice = (cityData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_CITY_TOTAL_PRICE_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/property/city-total-price`,
        cityData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_CITY_TOTAL_PRICE_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_CITY_TOTAL_PRICE_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_CITY_TOTAL_PRICE_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Failed to fetch city total price!");
      return error?.response?.data;
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};
